module.exports = __webpack_public_path__ + "static/media/Dwebble_gaussian2.2611f81b.png";